<template>
  <div class="wrapper">
    <AvalInputSearchSecondary
      v-if="themesStore.allThemes.length > 0"
      ref="searchInputRef"
      v-model="searchValue"
      :autofocus="true"
      :placeholder="t('news_page_themes_switcher.input.search')"
    />
    <ul class="themes-list scroll">
      <li
        v-if="themesStore.allThemes.length > 1"
        class="themes-list__item"
        :class="{'themes-list__item--active': props.isAllThemesChosen}"
        @click="choseAllThemes(!props.isAllThemesChosen)"
      >
        {{ t('news_page_themes_switcher.label.theme_all') }}
      </li>

      <li
        v-for="(theme, index) in themesStore.allThemes"
        v-show="checkSearchValue(theme.name, searchValue)"
        :key="theme.id"
        class="themes-list__item"
        :class="{
          'themes-list__item--active': themesStore.chosenThemes.includes(theme.id)}"
        @click="chooseTheme(theme)"
      >
        <div
          v-if="themesStore.allThemes.length > 1"
          class="themes-list__switcher-box"
        >
          <button
            v-show="index !== 0"
            class="themes-list__switcher-button"
            @click.stop="upTheme(index, theme)"
          >
            <UpThemeIcon />
          </button>
          <button
            v-show="index !== themesStore.allThemes.length - 1"
            class="themes-list__switcher-button"
            @click.stop="downTheme(index, theme)"
          >
            <DownThemeIcon />
          </button>
        </div>
        {{ theme.name }}
        <button
          v-if="LKStore.user.roleNames.includes('аналитик') || LKStore.project.is_owner"
          class="themes-list__menu-button"
          :class="
            {'themes-list__menu-button--active': isShowMenu && state.chosenItem.id === theme.id,
             'themes-list__menu-button--chosen': themesStore.chosenThemes.includes(theme.id)}"
          @click.stop="openThemeMenu($event, theme)"
        >
          <DotsIcon class="themes-list__item-icon" />
        </button>
      </li>
    </ul>
  </div>

  <NewsPageSwitcherMenu
    v-if="isShowMenu && state.chosenItem"
    :coords="state.coords"
    type="blocks"
    :is-tracked-rubric="state.chosenItem.is_tracked"
    @close="closeEdit"
    @edit="openEditPopup"
    @delete="openDeletePopup"
  />
</template>
<script setup>
import { useRubricsStore } from "@/store/NewsFeed/rubrics";
import {reactive, ref, defineProps, defineEmits, onMounted} from "vue";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { t } from "@/controllerLK/AvalLocalization";
import {debounce } from "@/functions/debouncer";
import { useLK } from "@/controllerLK/LKstore";
import DotsIcon from "@/components/Icons/DotsIcon.vue";
import NewsPageSwitcherMenu from "@/components/NewsPage/NewsPageRoof/NewsPageSwitcherMenu.vue";
import UpThemeIcon from "@/components/Icons/UpThemeIcon.vue";
import DownThemeIcon from "@/components/Icons/DownThemeIcon.vue";
import { useThemesStore } from "@/store/NewsFeed/themes";

const props = defineProps({
  activeTheme: {
    type: [Object, null],
    default: () => {}
  },
  isAllThemesChosen: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["open-edit-popup", "open-delete-popup", "set-active-theme"]);

const newsFeedStore = useNewsFeedStore();
const rubricsStore = useRubricsStore();
const themesStore = useThemesStore();
const LKStore = useLK();

const state = reactive({
  chosenItem: null,
  coords: {
    top: "0px",
    left: "0px"
  },
  isAllThemeChosen: {
    type: Boolean,
    default: false
  }
});

onMounted(() => {
  if (searchInputRef.value) {
    searchInputRef.value.focus();
  }
});

// Реф на поисковую строку
const searchInputRef = ref(null);

// Значение поиска рубрики
const searchValue = ref("");

// Функция проверки наличия рубрики по поисковому запросу
const checkSearchValue = (string, substring) => {
  return string.toLowerCase().includes(substring.toLowerCase());
};

// Всплывающее меню рубрик
// Состояние меню
const isShowMenu = ref(false);

// Открытие меню
const openThemeMenu = (event, theme) => {
  emit("set-active-theme", theme);
  isShowMenu.value = true;
  state.chosenItem = theme;
  findMenuCoordinate(event);
};

// Закрытие меню
function closeEdit() {
  isShowMenu.value = false;
  state.chosenItem = null;
}

// Координаты меню для открытия.
function findMenuCoordinate(e) {
  const rect = e.target.getBoundingClientRect();
  state.coords.top = rect.top + rect.height + 5 + "px";
  state.coords.left = rect.left + "px";
}

// Темы

// Функция выбора всех тем и рубрик из этих тем.
const choseAllThemes = () => {
  rubricsStore.chosenRubrics = [];
  if (themesStore.chosenThemes.length === themesStore.allThemes.length) {
    themesStore.chosenThemes = [];
  } else {
    themesStore.chosenThemes = themesStore.allThemes.map((theme) => theme.id);
    themesStore.allThemes.forEach((theme) => rubricsStore.chosenRubrics.push(...theme.rubric_ids));
    themesStore.chosenThemes = [...new Set(themesStore.chosenThemes)];
    rubricsStore.chosenRubrics = [...new Set(rubricsStore.chosenRubrics)];
  }
  updateNewsDebounced();
};

// Выбор темы
function chooseTheme(theme) {
  if (themesStore.chosenThemes.length > 0 && themesStore.chosenThemes[0] === theme.id) {
    themesStore.chosenThemes = [];
    rubricsStore.chosenRubrics = rubricsStore.rubricsOnMonitoring;
  } else {
    themesStore.chosenThemes = [theme.id];
    rubricsStore.chosenRubrics = theme.rubric_ids;
  }

  // сбрасываем поиск и обновляем ленту
  newsFeedStore.searchValue = "";
  updateNewsDebounced();
}

// Функция получения списка новостей
const updateNews = () => {
  newsFeedStore.clearNewsFeed();
  newsFeedStore.getNews();
};
const updateNewsDebounced = debounce(updateNews, 700);


// Событие открытия модального окна редактирования темы
function openEditPopup() {
  emit("open-edit-popup");
  closeEdit();
}

// Событие открытие модального окна удаления темы
function openDeletePopup() {
  emit("open-delete-popup", props.activeTheme);
  closeEdit();
}

// Опустить тему вниз по списку.
const downTheme = (index, item) => {
  themesStore.allThemes[index] = themesStore.allThemes[index + 1];
  themesStore.allThemes[index + 1] = item;
  themesStore.changeThemeNumber(item.id, false);
};

// Поднять тему вверх по списку
const upTheme = (index, item) => {
  themesStore.allThemes[index] = themesStore.allThemes[index - 1];
  themesStore.allThemes[index - 1] = item;
  themesStore.changeThemeNumber(item.id, true);
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.themes-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 450px;
  padding-right: 2px;

  &__switcher {
    &-box {
      min-width: 40px;
      width: 40px;
    }
    &-button {
      width: 20px;
      height: 20px;
      background: transparent;
    }
  }

  &__menu-button {
    background-color: transparent;
    cursor: pointer;
    user-select: none;
    width: 22px;
    height: 22px;
    min-width: 22px;
    min-height: 22px;
    color: var(--purple-purple50);
    align-self: flex-start;
    margin-left: auto;

    &:hover {
      color: var(--blue-blue80);
    }

    &--chosen {
      color: var(--icon-icon-on);
    }

    &--active {
      background-color: var(--background-bg-main);
      border-radius: 50%;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    padding: 6px 14px;
    border-radius: 8px;
    gap: 5px;
    overflow-wrap: anywhere;
    position: relative;

    &-checkbox {
      pointer-events: none;
    }

    &-title {
      flex: 1;
    }

    &:hover:not(&--disabled) {
      &:deep(input) {
        border-color: var(--icon-icon-on);
      }
    }

    &:hover:not(&--active) {
      background: var(--background-bg-hover);
    }

    &--active {
      color: var(--text-text-on);
      &:hover {
        background-color: var(--background-bg-active-hover);
      }
    }

    &--active :deep(.checkbox__label) {
      color: var(--text-text-on);
    }

    :deep(label) {
      cursor: pointer;
    }

    :deep(input) {
      align-self: flex-start;
    }
  }
}
</style>